// DS: i3.19
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const GiveFeedback = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M20 3a1 1 0 011 1v11.586a1 1 0 01-.293.707l-1.414 1.414a1 1 0 01-.707.293H7l-2.707 2.707a1 1 0 01-.707.293H3.5a.5.5 0 01-.5-.5V13h.02V5.411a1 1 0 01.29-.703l1.396-1.411A1 1 0 015.417 3H20zm-8 10a1 1 0 100 2 1 1 0 000-2zm0-7a1 1 0 00-.974.77l-.02.113L11 7v4l.007.117a1 1 0 001.967.112l.02-.112L13 11V7l-.007-.117A1 1 0 0012 6z"
    })));
GiveFeedback.displayName = 'GiveFeedback';
export default GiveFeedback;
